<template>
  <div class="contents">
    <div class="d-flex section-title-with-back" v-if="id">
      <img src="@/assets/images/Icon awesome-pen.png" alt width="27.3" height="27.3" />
      <p class="title-bk">先生管理</p>
    </div>
    <div class="d-flex section-title-with-back" v-else>
      <img src="@/assets/images/Icon awesome-pen.png" alt width="27.3" height="27.3" />
      <p class="title-bk">パスワード変更</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: id ? 'teacher-id-detail' : 'teacher-profile-setting', params: id ? { id } : {} }">
        戻る
      </router-link>
    </div>
    <div class="container">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(confirmChanged)" ref="form">
          <table class="table table-form">
            <tbody>
              <tr v-if="id">
                <th scope="row">法人名（法人ID）</th>
                <td />
                <td>{{ currentCorporationDisplay }}</td>
              </tr>
              <tr v-if="id">
                <th scope="row">ブランド名（ブランドID）</th>
                <td />
                <td>{{ currentBrandDisplay }}</td>
              </tr>
              <tr>
                <th scope="row">先生名（先生ID）</th>
                <td />
                <td>{{ currentTeacherDisplay }}</td>
              </tr>
              <PasswordField vid="password" v-model="password" extraRules="required" />
              <PasswordField
                v-model="verifyPassword"
                extraRules="required|verify_password:password"
                label="パスワード（確認）"
              />
            </tbody>
          </table>
          <div class="text-center">
            <button type="submit" class="btn-red">実行</button>
          </div>
        </form>
      </ValidationObserver>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        :green-button-title="id ? '先生情報に戻る' : '設定に戻る'"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header>先生情報</template>
        <template v-slot:body>パスワードの変更が完了しました</template>
      </PopUpHolder>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import store from '@/store/index.js';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import { ValidationObserver } from 'vee-validate';
import PasswordField from '@/components/forms/PasswordField.vue';
import { basicCorporationNameIdPresent, basicBrandNameIdPresent, basicTeacherNameIdPresent } from '@/presenters/fields';

export default {
  props: {
    id: {
      type: [String, Number],
      required: false,
    },
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('teacher/fetchTeacher', routeTo.params.id).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  data() {
    return {
      password: '',
      verifyPassword: '',
    };
  },
  components: {
    ValidationObserver,
    PasswordField,
    PopUpHolder,
  },
  computed: {
    currentTeacher() {
      return this.teacher.teacher;
    },
    currentCorporationDisplay() {
      return basicCorporationNameIdPresent(this.currentTeacher.corporation);
    },
    currentBrandDisplay() {
      return basicBrandNameIdPresent(this.currentTeacher.brand);
    },
    currentTeacherDisplay() {
      return basicTeacherNameIdPresent(this.currentTeacher);
    },
    ...mapState(['teacher']),
  },
  methods: {
    confirmChanged() {
      let payload = {
        id: this.currentTeacher.id,
        password: this.password,
      };
      this.changeTeacherPassword(payload).then(() => {
        this.$logger.debug('Show success popup');
        this.$refs['popup_holder'].show();
      });
    },
    popupConfirmed() {
      this.$logger.debug('Popup done');
      if (this.id) {
        // This path is for TIE, Corporation and Brand Role
        this.$logger.debug('Password Changed for ID: ' + this.id);
        this.$router.push({ name: 'teacher-id-detail', params: { id: this.id } });
      } else {
        // This path is for Teacher Role
        this.$logger.debug('Password Changed');
        this.$router.push({ name: 'teacher-profile-setting' });
      }
    },
    ...mapActions('teacher', ['changeTeacherPassword']),
  },
};
</script>

<style scoped>
.btn-red {
  margin-left: 0px;
}
.line-break {
  width: 100%;
}
</style>
